import * as Yup from 'yup';

export const matchedInitialValues = {
    description: '',
    startDate: null,
    endDate: null,
    amount: '',
    bankAccount: 'all',
    type: { value: 'all', label: 'All' },
    referenceId: '',
    matchedBy: { value: 'all', label: 'All users' },
};

export const matchedSchema = Yup.object({
    endDate: Yup.date().nullable(),
    amount: Yup.number().nullable(),
    startDate: Yup.date().nullable(),
    description: Yup.string().nullable(),
    referenceId: Yup.string().nullable(),
    bankAccount: Yup.string().nullable(),
    matchedBy: Yup.object()
        .shape({
            value: Yup.string().required('User value is required'),
            label: Yup.string().required('User label is required'),
        })
        .nullable(),
    type: Yup.object()
        .shape({
            value: Yup.string().required('Type value is required'),
            label: Yup.string().required('Type label is required'),
        })
        .nullable(),
});
